import { Home } from '@portals/icons';
import { MarketingType, RawFilterConfigItem } from '@portals/sip-client-data/src/general/ApiClientTypes';
import { useFormikContext } from 'formik';
import { getFixedT } from 'i18next';
import React, { useCallback, useContext, useMemo } from 'react';

import { getAllMarketingTypes } from '../../../../../config';
import { CatalogsContext } from '../../../../../context';
import { getEstateTypeIdOptions, getMarketingTypeEstateTypeIdLabel } from '../../../../../utils';
import { ButtonGroupSelectTextField } from '../../../..';

type EstateTypeId = RawFilterConfigItem['estateTypeId'];
interface Props {
  estateTypeIdFieldName?: string;
  marketingTypeFieldName?: string;
}
const t = getFixedT(null, 'core-immobilien');

export const MarketingTypeEstateTypeIdFilter: React.FC<Props> = ({
  estateTypeIdFieldName = 'estateTypeId',
  marketingTypeFieldName = 'marketingType',
}: Props) => {
  const { values, setFieldTouched, setFieldValue } = useFormikContext();
  const { estateSubTypes: catalogsEstateSubTypes } = useContext(CatalogsContext);
  const estateTypeIdValue = values[estateTypeIdFieldName];
  const marketingValue = values[marketingTypeFieldName];
  const marketingTypeEstateTypeIdTextfieldValue = useMemo(
    () =>
      getMarketingTypeEstateTypeIdLabel({
        estateSubTypes: catalogsEstateSubTypes,
        marketingType: marketingValue,
        estateTypeId: estateTypeIdValue,
      }),
    [catalogsEstateSubTypes, estateTypeIdValue, marketingValue]
  );

  const onButtonClick = useCallback(
    (value: MarketingType) => {
      setFieldTouched(marketingTypeFieldName, true);
      setFieldValue(marketingTypeFieldName, value, true);
      return false;
    },
    [marketingTypeFieldName, setFieldTouched, setFieldValue]
  );

  const onSelectClick = useCallback(
    (value: EstateTypeId) => {
      setFieldTouched(estateTypeIdFieldName, true);
      setFieldValue(estateTypeIdFieldName, value, true);
      return true;
    },
    [estateTypeIdFieldName, setFieldTouched, setFieldValue]
  );

  return (
    <ButtonGroupSelectTextField
      InputAdornmentIcon={Home}
      label={t('what')}
      inputValue={marketingTypeEstateTypeIdTextfieldValue}
      buttonOptions={getAllMarketingTypes(t)}
      buttonValue={marketingValue}
      selectOptions={getEstateTypeIdOptions(catalogsEstateSubTypes, marketingValue)}
      selectValue={estateTypeIdValue}
      highlightSelectedOption={true}
      onButtonClick={onButtonClick}
      onSelectClick={onSelectClick}
      menuMaxHeight={310}
    />
  );
};

MarketingTypeEstateTypeIdFilter.displayName = 'MarketingTypeEstateTypeIdFilter';
